import { formatMonthShort } from './dateUtils';

export const getChartData = (monthlyData) => {
  return monthlyData.map(data => ({
    month: formatMonthShort(data.month),
    'Net Worth': data.netWorth,
    'Assets': data.totalAssets,
    'Debts': data.totalDebts
  }));
};

// Growth rate off a numeric time series: a compound monthly rate when every
// value is positive (so simulations can compound it forward), otherwise a
// flat average delta per month (handles series that cross zero, e.g. debt
// payoff or a net worth that started negative).
export const getGrowthInfo = (series, { annualize = false } = {}) => {
  if (series.length < 2) return null;

  if (series[0] > 0 && series.every(v => v > 0)) {
    const monthlyRate = Math.pow(series[series.length - 1] / series[0], 1 / (series.length - 1)) - 1;
    return annualize
      ? { type: 'rate', monthly: monthlyRate, annual: (Math.pow(1 + monthlyRate, 12) - 1) * 100 }
      : { type: 'rate', monthly: monthlyRate };
  }

  let total = 0;
  for (let i = 1; i < series.length; i++) total += series[i] - series[i - 1];
  return { type: 'delta', monthly: total / (series.length - 1) };
};

export const getMonthlyChange = (monthlyData) => {
  if (monthlyData.length < 2) return null;

  return monthlyData.slice(1).map((data, index) => {
    const prevData = monthlyData[index];
    return {
      month: formatMonthShort(data.month),
      change: data.netWorth - prevData.netWorth
    };
  });
};
